import {Project} from "../api/Project";
import {foodhubProject} from "../projects/FoodHubWebsite";
import {videoRankerProject} from "../projects/VideoRanker";
import {arrowTransProject} from "../projects/ArrowTrans";
import {docuConverterProject} from "../projects/DocuConverter";
import {arrowMateProject} from "../projects/ArrowMate";
import {portfolioProject} from "../projects/Portfolio";
import {galleryKitProject} from "../projects/GalleryKit";
import {jacoturaProject} from "../projects/Jacotua";

export const projects: Project[] = [
    foodhubProject,
    videoRankerProject,
    arrowTransProject,
    docuConverterProject,
    arrowMateProject,
    portfolioProject,
    galleryKitProject,
    jacoturaProject,
];
